import Layout from "@/layouts/Layout.vue";
import itemsList from "@/views/items/list.vue";
import itemPreview from "@/views/items/preview.vue";
import itemsSearch from "@/views/items/search.vue";

import { UserPermissions } from "@/utils";

let itemsRoute = {
  path: "/items",
  component: Layout,
  name: "Артикули ",
  redirect: "/items",
  hidden: true,
  meta: {
    actions: [UserPermissions.USER, UserPermissions.ADMIN],
  },
  children: [
    {
      path: "/items",
      name: "Артикули",
      component: itemsList,
      meta: {
        title: "Артикули",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-book-open-page-variant",
      },
      hidden: false
    },
    {
      path: "/items/:id",
      name: "Преглед на артикул",
      component: itemPreview,
      meta: {
        title: "Преглед на артикул",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-book-open-page-variant",
        goBackTitle: "Обратно към артикули",
      },
      hidden: true
    }
  ]
}

export default itemsRoute;